import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { ExchangeRateService } from '@core/services/entities/exchange-rate.service';
import { ExchangeRateResponseDto } from '@domain/exchange-rate/dtos/exchange-rate.response.dto';
import { ListExchangeRateRequestDto } from '@domain/exchange-rate/dtos/list-exchange-rate.request.dto';
import { ExchangeRateRepository } from '@domain/exchange-rate/repositories/exchange-rate.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateRepositoryService implements ExchangeRateRepository {
  constructor(private exchangeRateService: ExchangeRateService) {}

  list(
    request: ListExchangeRateRequestDto,
  ): Observable<ApiResponse<PageableResponse<ExchangeRateResponseDto>>> {
    return this.exchangeRateService.list(request);
  }
}
